module.exports = __webpack_public_path__ + "media/images/front/icons_logout-002ce7e8aa192a334a8fe5543fe8924f.png";